import { useEffect } from 'react';

import KeyboardBackspaceRoundedIcon from '@mui/icons-material/KeyboardBackspaceRounded';
import Button from '@mui/material/Button';
import { useNavigate } from 'react-router-dom';
import { down } from 'styled-breakpoints';
import { useBreakpoint } from 'styled-breakpoints/react-styled';

import { Header } from 'components/templates/layouts/PageLayout/Header';
import { useAppTitle } from 'hooks/store/useAppTitle';
import useElementSize from 'hooks/utils/useElementSize';

import { NotFoundWrapper } from './NotFoundPage.styled';

type NotFoundPageProps = {
    backPath?: string;
};

export const NotFoundPage = ({ backPath }: NotFoundPageProps): JSX.Element => {
    const { setAppTitle } = useAppTitle();
    const navigate = useNavigate();

    useEffect(() => {
        setAppTitle('Страница не найдена');
    }, [setAppTitle]);

    const [headerRef, size] = useElementSize<HTMLDivElement>();

    const small = useBreakpoint(down('sm'));

    const smOffset = `calc(100% - ${size.height}px - 40px)`;
    const lgOffset = `calc(100% - ${size.height}px - 80px)`;

    return (
        <div
            style={{
                height: small ? smOffset : lgOffset,
            }}
            className="WRAPPER"
        >
            <Header ref={headerRef} />
            <NotFoundWrapper>
                <div className="bigFont">404</div>
                <div className="smallFont">Страница не найдена</div>
                <Button
                    startIcon={<KeyboardBackspaceRoundedIcon />}
                    variant="contained"
                    size="large"
                    sx={{
                        color: 'black',
                        backgroundColor: '#fff',
                        px: 7,
                        ':hover': { backgroundColor: '#23A457', color: '#fff' },
                    }}
                    onClick={() =>
                        navigate(backPath ?? '/doklad/o-doklade', {
                            replace: true,
                        })
                    }
                >
                    Вернуться назад
                </Button>
            </NotFoundWrapper>
        </div>
    );
};
